














































import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import Getsudo from '@/tcw/domain/Getsudo'
import Shimebi from '@/tcw/domain/Shimebi'

@Component
export default class TcwGetsudoPicker extends Vue {
  @Prop({ type: Getsudo, default: null })
  private value!: Getsudo | null
  @Prop({ type: Boolean, default: true })
  private currentButton!: boolean
  @Prop({ type: Boolean, default: false })
  private isCurrentGetsudo!: boolean
  @Prop({ default: 'yyyy年M月' })
  private format!: string
  @Prop({ type: Boolean, default: false })
  private disabled!: boolean
  @Prop({ type: Boolean, default: false })
  private prevNextButton!: boolean
  @Prop({ type: Shimebi, default: Shimebi.default() })
  private shimebi!: Shimebi

  get dateValue(): Date {
    if (this.value) {
      return this.value.getDate()
    } else {
      return Getsudo.now(this.shimebi).getDate()
    }
  }
  set dateValue(value: Date) {
    const newGetsudo = Getsudo.generateByDate(value, this.shimebi)
    this.input(newGetsudo)
    this.change(newGetsudo)
  }
  get isMobile(): boolean {
    return this.$mq === 'sp'
  }

  @Emit()
  private input(_value: Getsudo): void {
    /**  */
  }

  // 今月度に変更ボタンクリックイベント
  @Emit()
  private clickCurrent(): void {
    /**  */
  }
  // カレンダー変更イベント
  @Emit()
  private selectCalendar(_value: Getsudo): void {
    /**  */
  }
  // 共通的な月度変更イベント
  @Emit()
  private change(_value: Getsudo): void {
    /**  */
  }
  @Emit()
  private nextMonth(): void {
    /** */
  }
  @Emit()
  private prevMonth(): void {
    /** */
  }

  /**
   * 今月に変更イベント
   */
  private changeCurrentGetsudo(): void {
    this.dateValue = Getsudo.now(this.shimebi).getDate()
    this.clickCurrent()
  }
  private changeMonth(value: Date): void {
    this.dateValue = value
    if (this.value) {
      this.selectCalendar(this.value)
    }
  }
}
